import styled from "@emotion/styled"

const HeroSectionWrapper = styled.section`
  position: relative;
`

export default HeroSectionWrapper
